import { PropTypes } from "prop-types"
import classNames from "classnames"

import InputText from "./InputText"
import Field from "../Field"
import fieldSchemaPropTypes from "../fieldSchemaPropTypes"
import errorPropTypes from "../errorPropTypes"

export function TextField(props) {
  const {
    className,
    error,
    id,
    label,
    labelId,
    name,
    schema,
    onChange,
    isClearable = true,
    touched = false,
    ...rest
  } = props
  const handleChange = e => onChange(name, e.target.value)
  const handleClear = () => onChange(name, "")

  return (
    <Field
      className={classNames("oj-text-field", className)}
      error={error}
      touched={touched}
      id={id}
    >
      <Field.Label id={labelId} inputId={id} label={label} required={schema.required}>
        <Field.Input
          {...schema}
          {...rest}
          id={id}
          error={error}
          name={name}
          onClear={handleClear}
          isClearable={isClearable}
        >
          {innerProps => (
            <InputText {...innerProps} onChange={handleChange} onClear={handleClear} />
          )}
        </Field.Input>
      </Field.Label>
    </Field>
  )
}

TextField.propTypes = {
  className: PropTypes.string,
  error: PropTypes.shape(errorPropTypes),
  id: PropTypes.string,
  label: PropTypes.node,
  labelId: PropTypes.string,
  name: PropTypes.string.isRequired,
  schema: PropTypes.shape(fieldSchemaPropTypes).isRequired,
  onChange: PropTypes.func.isRequired,
  isClearable: PropTypes.bool,
  touched: PropTypes.bool
}

export default TextField
